import * as React from 'react'

import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import { IReferral } from '@sales-center/common'
import { Theme } from '@mui/material/styles'

type Props = {
  referral: IReferral
}

export function TidalNoReferralPreview(props: Props) {
  const { referral } = props

  return (
    <Paper
      variant="outlined"
      sx={{
        backgroundColor: (theme: Theme) => theme.palette.background.default,
        border: 'solid 1px #e0e0e0',
        padding: (theme: Theme) => theme.spacing(1.5),
      }}
    >
      <Typography variant="subtitle2">{referral.referralValue}</Typography>
    </Paper>
  )
}
